import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const quickActions = [
    {
      title: "API Documentation",
      description: "Browse complete API reference and guides",
      icon: "FileText",
      color: "primary",
      action: () => window.location.href = '/api-documentation'
    },
    {
      title: "Download SDKs",
      description: "Get client libraries for popular languages",
      icon: "Download",
      color: "secondary",
      action: () => window.open('/api-documentation#csharp-sdk', '_blank')
    },
    {
      title: "Create Support Ticket",
      description: "Get help from our technical support team",
      icon: "MessageSquare",
      color: "accent",
      action: () => console.log('Create support ticket')
    },
    {
      title: "View Status Page",
      description: "Check system status and uptime metrics",
      icon: "Activity",
      color: "warning",
      action: () => console.log('View status page')
    }
  ];

  const resources = [
    {
      title: "Getting Started Guide",
      description: "Step-by-step integration tutorial",
      icon: "BookOpen",
      link: "#"
    },
    {
      title: "Code Examples",
      description: "Sample implementations and snippets",
      icon: "Code",
      link: "#"
    },
    {
      title: "Best Practices",
      description: "Optimization tips and recommendations",
      icon: "Lightbulb",
      link: "#"
    },
    {
      title: "Community Forum",
      description: "Connect with other developers",
      icon: "Users",
      link: "#"
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary':
        return 'bg-primary/10 text-primary border-primary/20';
      case 'secondary':
        return 'bg-secondary/10 text-secondary border-secondary/20';
      case 'accent':
        return 'bg-accent/10 text-accent border-accent/20';
      case 'warning':
        return 'bg-warning/10 text-warning border-warning/20';
      default:
        return 'bg-muted/10 text-muted-foreground border-border';
    }
  };

  return (
    <div className="space-y-6">
      {/* Quick Actions */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h2 className="text-xl font-semibold text-foreground mb-6">Quick Actions</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {quickActions?.map((action, index) => (
            <button
              key={index}
              onClick={action?.action}
              className="p-4 bg-muted/30 rounded-lg border border-border hover:bg-muted/50 transition-all duration-200 text-left group"
            >
              <div className="flex items-start space-x-4">
                <div className={`p-3 rounded-lg border ${getColorClasses(action?.color)} group-hover:scale-110 transition-transform duration-200`}>
                  <Icon name={action?.icon} size={20} />
                </div>
                <div className="flex-1">
                  <h3 className="font-medium text-foreground mb-1 group-hover:text-primary transition-colors">
                    {action?.title}
                  </h3>
                  <p className="text-sm text-muted-foreground">{action?.description}</p>
                </div>
                <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all duration-200" />
              </div>
            </button>
          ))}
        </div>
      </div>
      {/* Developer Resources */}
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-foreground">Developer Resources</h2>
          <Button
            variant="ghost"
            size="sm"
            iconName="ExternalLink"
            iconPosition="right"
            className="text-xs"
          >
            View All
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {resources?.map((resource, index) => (
            <a
              key={index}
              href={resource?.link}
              className="p-4 bg-muted/30 rounded-lg border border-border hover:bg-muted/50 transition-all duration-200 group block"
            >
              <div className="flex items-start space-x-3">
                <div className="p-2 bg-primary/10 rounded-lg border border-primary/20 group-hover:bg-primary/20 transition-colors">
                  <Icon name={resource?.icon} size={16} className="text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-medium text-foreground mb-1 group-hover:text-primary transition-colors">
                    {resource?.title}
                  </h3>
                  <p className="text-sm text-muted-foreground">{resource?.description}</p>
                </div>
                <Icon name="ArrowUpRight" size={14} className="text-muted-foreground group-hover:text-primary transition-colors" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;